import * as React from "react";
import {observer} from "mobx-react";
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useTheme} from "@mui/material";
import useFeature from "../../useFeature";
import NewsFeature from "./NewsFeature";
import {styles} from "./NewsStyles";
import {useApplication} from "../../ApplicationProvider";

function NewsScreen() {
    const theme = useTheme();
    const style = styles(theme);
    const application = useApplication();
    const feature = useFeature(() => new NewsFeature(application), [application]);

    if (!feature || !feature.loaded || !feature.isOpen) {
        return null;
    }

    return (
        <React.Fragment>
            <Dialog open={feature.isOpen} onClose={() => feature.dismiss()} PaperProps={{sx: style.dialogPaper}}>
                <DialogTitle>Novedades</DialogTitle>
                <DialogContent>
                    {feature.newsToShow.map((news) => (
                        <Box key={news.id} sx={style.newsBlock}>
                            {news.illustration && (
                                <Box component="img" src={news.illustration} alt={news.illustrationAlt} sx={style.newsIllustration}/>
                            )}
                            <Typography sx={style.newsTitle} variant="h6">{news.title}</Typography>
                            <Typography sx={style.newsBody} variant="body2">{news.body}</Typography>
                        </Box>
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => feature.dismiss()}>Entendido</Button>
                </DialogActions>
            </Dialog>
            {feature.newsToShow.filter((news) => news.pointer).map((news) => (
                <news.pointer key={news.id}/>
            ))}
        </React.Fragment>
    );
}

export default observer(NewsScreen);
